import * as React from 'react';

import {FormStepTemplates} from '../../forms';

import {StageItemSidebar} from './sidebar/stage-item-sidebar';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class StepTemplateEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        const {isNew, parentId, ...restProps} = this.props;

        return (
            <StageItemSidebar
                onSave={this.handleSidebarFormSave}
                parentId={parentId}
                title={isNew ? 'New task' : 'Edit task'}
            >
                <FormStepTemplates
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    stageId={parentId}
                    {...restProps}
                />
            </StageItemSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
